

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';

export interface LabGroupParameter extends Parameter {
    searchTerm: number;
    orderBy: string;

}

export interface LabGroup {
    id?: any;
    serviceType?:any;                           
    sortOrderId:number;
    serviceId:any;
    labTestId:any;
    isActive?:string;
    tenantId: any;
    labTestName:string;
    sscName:string;
    sscid:any;
    unitId?:any;
    unitName?:string;
    parameters?: LabGroupParameter[];
    links?: any;
    formula?:string;
    allowEdit?:string;
}


export abstract class LabGroupData {
    abstract list(url: string): Observable<LabGroup[]>;
    abstract create(url: string, data: LabGroup): Observable<LabGroup[]>;
    abstract update(url: string, data: LabGroup): Observable<LabGroup>;
    abstract createList(url: string, data: any): Observable<any>;
    abstract updateList(url: string, data: any): Observable<any>;
    abstract delete(url: string): Observable<any>;
    abstract postData(url:string,data:any[]):Observable<any>;
}
